import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.esm.js';
import { DialogModal, Slot, Text, StarRating, TextArea } from '@costar-ui/components';
import React, { useState, useCallback } from 'react';

var ShareFeedbackModalDialog = function ShareFeedbackModalDialog(props) {
  var dialog = props.dialog,
    infoTextArr = props.infoTextArr,
    textareaPlaceholder = props.textareaPlaceholder,
    triggerElement = props.triggerElement;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    starRating = _useState2[0],
    setStarRating = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    feedBackText = _useState4[0],
    setFeedbackText = _useState4[1];
  var handleStarRatingClick = useCallback(function (rating) {
    if (Array.isArray(rating)) {
      setStarRating(rating[0]); // We only need the first rating value
    } else {
      setStarRating(rating);
    }
  }, []);
  var handleTextAreaChange = useCallback(function (e) {
    var value = e.target.value || '';
    setFeedbackText(value);
  }, []);
  var handleSubmit = useCallback(function () {
    var _dialog$onAction, _dialog$onCancel;
    dialog === null || dialog === void 0 || (_dialog$onAction = dialog.onAction) === null || _dialog$onAction === void 0 || _dialog$onAction.call(dialog, {
      starRating: starRating > 0 ? starRating : undefined,
      feedBackText: feedBackText
    });
    setStarRating(0);
    setFeedbackText('');
    dialog === null || dialog === void 0 || (_dialog$onCancel = dialog.onCancel) === null || _dialog$onCancel === void 0 || _dialog$onCancel.call(dialog);
  }, [starRating, feedBackText, dialog]);
  var handleCancel = useCallback(function () {
    var _dialog$onCancel2;
    setStarRating(0);
    setFeedbackText('');
    dialog === null || dialog === void 0 || (_dialog$onCancel2 = dialog.onCancel) === null || _dialog$onCancel2 === void 0 || _dialog$onCancel2.call(dialog);
  }, [dialog]);
  var isSubmitDisabledStarRating = starRating === 0;
  var isSubmitDisabledTextArea = feedBackText.length === 0;
  return /*#__PURE__*/React.createElement(DialogModal, {
    title: dialog === null || dialog === void 0 ? void 0 : dialog.heading,
    isOpen: dialog === null || dialog === void 0 ? void 0 : dialog.isOpen,
    size: "sm",
    showCloseIcon: true,
    onClose: handleCancel,
    onAction: handleSubmit,
    actionLabel: dialog === null || dialog === void 0 ? void 0 : dialog.actionLabel,
    actionDisabled: isSubmitDisabledStarRating ? isSubmitDisabledTextArea : false,
    onCancel: handleCancel,
    cancelLabel: dialog === null || dialog === void 0 ? void 0 : dialog.cancelLabel,
    triggerElement: triggerElement,
    className: "z-[2500]"
  }, /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    gap: "3xl",
    testId: "share-feedback-dialog-content"
  }, Array.isArray(infoTextArr) && (infoTextArr === null || infoTextArr === void 0 ? void 0 : infoTextArr.length) > 0 && /*#__PURE__*/React.createElement(Slot, {
    gap: "lg",
    direction: "vertical"
  }, infoTextArr.map(function (info, i) {
    return /*#__PURE__*/React.createElement(Text, {
      variant: "text-16",
      testId: "info-text-".concat(i),
      key: "info-text-".concat(i)
    }, info);
  })), /*#__PURE__*/React.createElement(StarRating, {
    mode: "rating",
    size: "lg",
    value: starRating,
    onClick: handleStarRatingClick,
    testId: "star-rating"
  }), /*#__PURE__*/React.createElement(TextArea, {
    resize: "vertical",
    value: feedBackText,
    placeholder: textareaPlaceholder,
    className: "h-40",
    onChange: handleTextAreaChange,
    testId: "textarea"
  })));
};
function StoryShareFeedbackModalDialog(props) {
  return /*#__PURE__*/React.createElement(ShareFeedbackModalDialog, props);
}

export { ShareFeedbackModalDialog, StoryShareFeedbackModalDialog };
//# sourceMappingURL=share-feedback-modal-dialog.esm.js.map
